import {APIService} from "../../common/APIService";
import {Ledger} from "../../dto/Ledger";
import {VatRate} from "../../dto/VatRate";

export class FinanceService extends APIService {
  // Ledgers //
  public async browseLedgers() {
    const json = await this.getJson<{data: object[]}>('ledgers')
    return json.data.map(item => Ledger.fromJson(item));
  }

  public async addLedger(code: string, type: string, description: string): Promise<Ledger> {
    const json = await this.postJson<{data: object[]}>('ledgers', {
      code: code,
      type: type,
      description: description,
    })
    return Ledger.fromJson(json.data)
  }

  public async editLedger(id: string, code: string, type: string, description: string): Promise<Ledger> {
    const json = await this.putJson<{data: object[]}>(`ledgers/${id}`, {
      code: code,
      type: type,
      description: description,
    })
    return Ledger.fromJson(json.data)
  }

  public async deleteLedger(id: string): Promise<void> {
    await this.deleteJson(`ledgers/${id}`)
  }

  // Vat Rates //
  public async browseVatRates() {
    const json = await this.getJson<{data: object[]}>('vat-rates')
    return json.data.map(item => VatRate.fromJson(item));
  }

  public async addVatRate(name: string, rate: number, enabled: boolean): Promise<VatRate> {
    const json = await this.postJson<{data: object[]}>('vat-rates', {
      name: name,
      rate: rate,
      enabled: enabled,
    })
    return VatRate.fromJson(json.data);
  }

  public async editVatRate(vatRateId: string, name: string, rate: number, enabled: boolean): Promise<VatRate> {
    const json = await this.putJson<{data: object[]}>(`vat-rates/${vatRateId}`, {
      name: name,
      rate: rate,
      enabled: enabled,
    })
    return VatRate.fromJson(json.data);
  }

  public async deleteVatRate(vatRateId: string): Promise<void> {
    await this.deleteJson(`vat-rates/${vatRateId}`)
  }
}